import pinimg from "./assets/orangeWingWhite.png"

export const state = [
  {
    "id": 67777,
    "name": "Andhra Pradesh ",
    "lat": 14.7504291,
    "lng": 78.57002559,
    "img": pinimg
  },

  {
    "id": 19333221,
    "name": "Indor ",
    "lat": 22.6665045,
    "lng": 75.778652,
    "img": pinimg
  },
  {
    "id": 193331,
    "name": "Assam ",
    "lat": 26.7499809,
    "lng": 94.21666744,
    "img": pinimg
  },
  {
    "id": 256108,
    "name": "Bihar ",
    "lat": 25.78541445,
    "lng": 87.4799727,
    "img": pinimg
  },
  {
    "id": 444439,
    "name": "Dadra And Nagar Haveli ",
    "lat": 20.26657819,
    "lng": 73.0166178,
    "img": pinimg
  },
  {
    "id": 507216,
    "name": "Delhi ",
    "lat": 28.6699929,
    "lng": 77.23000403,
    "img": pinimg
  },
  {
    "id": 569993,
    "name": "Goa ",
    "lat": 15.491997,
    "lng": 73.81800065,
    "img": pinimg
  },
  {
    "id": 695547,
    "name": "Himachal Pradesh ",
    "lat": 31.10002545,
    "lng": 77.16659704,
    "img": pinimg
  },
  {
    "id": 821101,
    "name": "Jharkhand ",
    "lat": 23.80039349,
    "lng": 86.41998572,
    "img": pinimg
  },
  {
    "id": 883878,
    "name": "Karnataka ",
    "lat": 12.57038129,
    "lng": 76.91999711,
    "img": pinimg
  },
  {
    "id": 946655,
    "name": "Kerala ",
    "lat": 8.900372741,
    "lng": 76.56999263,
    "img": pinimg
  },
  {
    "id": 1072209,
    "name": "Madhya Pradesh ",
    "lat": 23.9627209,
    "lng": 76.1788748,
    "img": pinimg
  },
  {
    "id": 107209,
    "name": "Telangana",
    "lat": 17.8631287,
    "lng": 77.2729128,
    "img": pinimg
  },
  {
    "id": 1134986,
    "name": "Maharashtra ",
    "lat": 18.8019424,
    "lng": 74.524961,
    "img": pinimg
  },
  {
    "id": 1197763,
    "name": "Manipur ",
    "lat": 24.79997072,
    "lng": 93.95001705,
    "img": pinimg
  },
  {
    "id": 1260540,
    "name": "Meghalaya ",
    "lat": 25.57049217,
    "lng": 91.8800142,
    "img": pinimg
  },
  {
    "id": 1323317,
    "name": "Mizoram ",
    "lat": 23.71039899,
    "lng": 92.72001461,
    "img": pinimg
  },
  {
    "id": 1386094,
    "name": "Nagaland ",
    "lat": 25.6669979,
    "lng": 94.11657019,
    "img": pinimg
  },
  {
    "id": 1448871,
    "name": "Orissa ",
    "lat": 19.82042971,
    "lng": 85.90001746,
    "img": pinimg
  },
  {
    "id": 1511648,
    "name": "Puducherry ",
    "lat": 11.93499371,
    "lng": 79.83000037,
    "img": pinimg
  },
  {
    "id": 1574425,
    "name": "Punjab ",
    "lat": 30.2087514,
    "lng": 74.8884749,
    "img": pinimg
  },
  {
    "id": 1637202,
    "name": "Rajasthan ",
    "lat": 26.44999921,
    "lng": 74.63998124,
    "img": pinimg
  },
  {
    "id": 1699979,
    "name": "Sikkim ",
    "lat": 27.3333303,
    "lng": 88.6166475,
    "img": pinimg
  },
  {
    "id": 1762756,
    "name": "Tamil Nadu ",
    "lat": 12.92038576,
    "lng": 79.15004187,
    "img": pinimg
  },
  {
    "id": 1825533,
    "name": "Tripura ",
    "lat": 23.83540428,
    "lng": 91.27999914,
    "img": pinimg
  },
  {
    "id": 1888310,
    "name": "Uttar Pradesh ",
    "lat": 27.1189737,
    "lng": 78.8823102,
    "img": pinimg
  },
  {
    "id": 1951087,
    "name": "Uttaranchal ",
    "lat": 30.32040895,
    "lng": 78.05000565,
    "img": pinimg
  },
  {
    "id": 2013864,
    "name": "West Bengal ",
    "lat": 22.58039044,
    "lng": 88.32994665,
    "img": pinimg
  },
  {
    "id": 1762756245,
    "name": "kanpur",
    "lat": 23.8343,
    "lng": 80.3894,
    "img": pinimg
  },
  {
    "id": 1825533245,
    "name": "katni",
    "lat": 26.4499,
    "lng": 80.3319,
    "img": pinimg
  },
  {
    "id": 1888310245,
    "name": "Bhopal",
    "lat": 23.2599,
    "lng": 77.4126,
    "img": pinimg
  },
  {
    "id": 1951087245,
    "name": "Madurai",
    "lat": 9.9252,
    "lng": 78.1198,
    "img": pinimg
  },
  {
    "id": 2013864245,
    "name": "Vishakapatnam",
    "lat": 17.6868,
    "lng": 83.2185,
    "img": pinimg
  },
  {
    "id": 2076641245,
    "name": "Tadmetla",
    "lat": 18.2838,
    "lng": 81.15,
    "img": pinimg
  },
  {
    "id": 2139418245,
    "name": "Ranchi",
    "lat": 23.3441,
    "lng": 85.3096,
    "img": pinimg
  },
  {
    "id": 2202195245,
    "name": "Patna",
    "lat": 25.5941,
    "lng": 85.1376,
    "img": pinimg
  },
  {
    "id": 2264972245,
    "name": "Gorakhpur",
    "lat": 26.7606,
    "lng": 83.3732,
    "img": pinimg
  },
  {
    "id": 6789090,
    "name": "Ahmedabad",
    "lat": 23.0225,
    "lng": 72.5714,
    "img": pinimg
  },
  {
    "id": 31245879,
    "name": "Bhuj",
    "lat": 23.242,
    "lng": 69.6669,
    "img": pinimg
  },
  {
    "id": 55702668,
    "name": "Nagpur",
    "lat": 21.1458,
    "lng": 79.0882,
    "img": pinimg
  },
  {
    "id": 80159457,
    "name": "Korba",
    "lat": 22.3595,
    "lng": 82.7501,
    "img": pinimg
  },
  {
    "id": 104616246,
    "name": "Jodhpur",
    "lat": 26.2389,
    "lng": 73.0243,
    "img": pinimg
  },
  {
    "id": 129073035,
    "name": "Udaipur",
    "lat": 24.5854,
    "lng": 73.7125,
    "img": pinimg
  },
  {
    "id": 12907305999,
    "name": "Jammu",
    "lat": 32.72674746092182,
    "lng": 74.8570927756818,
    "img": pinimg
  },
]